import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { createCrudHooks } from '../../shared/api/crud-hooks';
import type { ListEnvelope } from '../../shared/api/genexus-query';
import type { DataTableQuery } from '../../shared/components/DataTable';
import { getTotals, listWithFilters, timesheetEntriesApi } from './api';
import type {
  TimesheetEntryDto,
  TimesheetEntryInput,
  TimesheetEntryListItem,
  TimesheetEntryTotalsFilters,
  TimesheetEntryTotalsResponse,
} from './types';

export const timesheetEntriesHooks = createCrudHooks<
  TimesheetEntryListItem,
  TimesheetEntryDto,
  TimesheetEntryInput,
  string
>({
  queryKey: ['timesheet-entries'],
  api: timesheetEntriesApi,
});

export function useTimesheetEntriesList(
  query: DataTableQuery,
  filters: TimesheetEntryTotalsFilters,
): UseQueryResult<ListEnvelope<TimesheetEntryListItem>, Error> {
  return useQuery({
    queryKey: ['timesheet-entries', 'list', query, filters],
    queryFn: () => listWithFilters(query, filters),
    placeholderData: (previous) => previous,
  });
}

export function useTimesheetEntryTotals(
  filters: TimesheetEntryTotalsFilters,
): UseQueryResult<TimesheetEntryTotalsResponse, Error> {
  return useQuery({
    queryKey: ['timesheet-entries', 'totals', filters],
    queryFn: () => getTotals(filters),
    placeholderData: (previous) => previous,
  });
}
